import { sameDimensions } from '@/utils/RateSheetMatching'
import { localeCompareAlphanumeric } from '@/utils/base'
import { rateSheetDefinitionLineFromServerToBuilder } from '@/components/account/account-scaling/rate-sheet-definitions/RateSheetDefinitions'

export const LineComparison = {
  Match: 'match',
  MissingFromInstance: 'missingFromInstance',
  RateDiffers: 'rateDiffers',
  NotInDefinition: 'notInDefinition'
}

function dimensionLabels ({ line }) {
  return [line.speciesGroup?.label, line.lengthGroup?.label, line.diameterGroup?.label, line.grade?.name, line.endUseSort?.name]
    .map(label => label ?? '')
}

function compareByDimensions (a, b) {
  const labelsA = dimensionLabels(a)
  const labelsB = dimensionLabels(b)
  for (let index = 0; index < labelsA.length; index++) {
    const result = localeCompareAlphanumeric(labelsA[index], labelsB[index])
    if (result !== 0) return result
  }
  return 0
}

function differenceCount ({ rateChangeCount, missingLineCount, extraLineCount }) {
  return rateChangeCount + missingLineCount + extraLineCount
}

export function matchesDefinition (activity, definition) {
  return definition.latestVersion !== null && differenceCount(activity) === 0
}

export function groupDefinitions (definitions, includeActivity) {
  return definitions
    .map(definition => {
      const activities = definition.activities
        .filter(activity => includeActivity(activity, definition))
        .sort((a, b) => localeCompareAlphanumeric(a.accountName, b.accountName) || localeCompareAlphanumeric(a.tractName ?? '', b.tractName ?? ''))
      const matchCount = activities.filter(activity => matchesDefinition(activity, definition)).length

      return {
        definition,
        activities,
        matchCount,
        differCount: activities.length - matchCount
      }
    })
    .filter(group => group.activities.length > 0)
    .sort((a, b) => localeCompareAlphanumeric(a.definition.name, b.definition.name))
}

export function compareLines (definitionLines, instanceLines) {
  const definitionBuilders = definitionLines.map(rateSheetDefinitionLineFromServerToBuilder)

  const definitionRows = definitionBuilders.map(definitionLine => {
    const instanceLine = instanceLines.find(line => sameDimensions(line, definitionLine))
    const comparison = instanceLine === undefined
      ? LineComparison.MissingFromInstance
      : Number(instanceLine.rate) === Number(definitionLine.rate) ? LineComparison.Match : LineComparison.RateDiffers

    return { line: definitionLine, comparison, definitionRate: definitionLine.rate, instanceRate: instanceLine?.rate ?? null }
  })

  const extraRows = instanceLines
    .filter(line => !definitionBuilders.some(definitionLine => sameDimensions(definitionLine, line)))
    .map(line => ({ line, comparison: LineComparison.NotInDefinition, definitionRate: null, instanceRate: line.rate }))

  return [...definitionRows.sort(compareByDimensions), ...extraRows.sort(compareByDimensions)]
    .map((row, index) => ({
      ...row,
      key: index,
      difference: row.comparison === LineComparison.RateDiffers ? row.instanceRate - row.definitionRate : null
    }))
}
